/** Generic loading placeholder. Use everywhere async work is in flight. */
export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-1 flex-col items-center justify-center gap-3 p-8 text-muted-foreground"
    >
      <span
        className="h-5 w-5 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-foreground"
        aria-hidden
      />
      <span className="text-sm">{label}</span>
    </div>
  );
}
